// API configuration for different environments
const API_BASE_URL = 'https://points-fyi-production.up.railway.app';

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// Export the base URL for direct use if needed
export { API_BASE_URL };

// Debug logging
// console.log('🔧 API Configuration:');
// console.log('  - import.meta.env.PROD:', import.meta.env.PROD);
// console.log('  - import.meta.env.MODE:', import.meta.env.MODE);
// console.log('  - window.location.hostname:', typeof window !== 'undefined' ? window.location.hostname : 'N/A (SSR)');
// console.log('  - API_BASE_URL:', API_BASE_URL);
